export default __webpack_public_path__ + "static/media/sowmz-beach-crop.05452e7f.jpg";